<template>
<section
  class="jumbo-panel"
  :class="{ reverse: reverse }">
  <BRow
    :noGutters="false">
    <BCol md="7">
      <BCardBody>
        <BCardText>
          <h1>{{header}}</h1>
          <slot>
            <p>{{ lead }}</p>
          </slot>
        </BCardText>
      </BCardBody>
    </BCol>
    <BCol md="5">
      <slot name="image">
        <BCardImg
          v-if="img"
          :src="src"
          class="rounded-0">
        </BCardImg>
      </slot>
    </BCol>
  </BRow>
</section>
</template>
<script>

import {
  BCard,
  BCardText,
  BCardGroup,
  BLink,
  BContainer,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  name: 'JumboPanel',
  props: {
    header: {
      type: String,
    },
    lead: {
      type: String,
    },
    reverse: {
      type: Boolean,
      default: false
    },
    img: {
      type: String,
    //  default: 'fieldwork.jpg'
    }
  },
  data() {
    return {};
  },
  components: {
    'b-link': BLink,
    'b-card': BCard,
    'b-card-group': BCardGroup,
    'b-card-text': BCardText,
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol,
  },
  created() {},
  watch: {},
  computed: {
    src(){
      try{
        let obj = require(`@/assets/img/${this.img}`);
        return obj;
      } catch(err){
        let i = Math.round(Math.random()*100+1)
        return `https://picsum.photos/400/400/?image=${i}`
      }
    }
  },
  methods: { }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.jumbo-panel  {

    &>.row {
      margin: 0 auto;
    }

  background-color: $color2;
  padding: 4rem 2rem;
  color: rgba(255,255,255,0.7);
  padding: 1rem;
  width: 100%;
  margin-bottom: 2rem;
  &>.header {
    h1 {
      font-size: 4.5rem;
      font-weight: 300;
      line-height: 1.2;
    }
  }

  @media screen and (min-width: $break-sm) {
    &>.row {
      width: 100%;
    }
  }

  @media screen and (min-width: $break-md) {
    &>.row {
      width: 100%;
    }
  }

  @media screen and (min-width: $break-lg) {
    &>.row {
      width: 70rem;
    }
  }

}
</style>
